
import axios from 'axios';
import React, { memo, useEffect, useState } from 'react'
import { constants } from '../../constants';

const EmailModal = memo(() => {
  
  const [inputMail, setInputMail] = useState('');
  const [notification, setNotification] = useState(false)
  const [msgNotification, setMsgNotification] = useState('')
  const URL = constants.test_host + '/mail/register'

  const hideNotification = () => {
    setTimeout(() => {
      setNotification(false);
    }, 3000);
  }

  const handleClick = async(e) => {
    e.preventDefault();
    if(!inputMail.includes('@')){
      setNotification(true);
      setMsgNotification('Por favor ingrese un correo válido.');
      hideNotification();
      return
    } 
    try {
      const {data} = await axios.post(URL, {email: inputMail}, {headers: {
        'Content-Type': 'application/json'
      }} );
      if(data.result) setInputMail('');
      setNotification(true);
      setMsgNotification(data.message);  
      hideNotification();
    } catch (error) {
        setNotification(true)
        setMsgNotification(error.response.data.message);
        hideNotification();
    }
    
  }

  return (  
          <>
            <div className=' container modal-header'>
                    
              <div className='modal-title'>
                <img alt="Logo SMS-APP" className="rounded-circle" style= {{width: '9%'}} src="/SMS-APP.png" />
                <h2 className="font-weight-bold text-white"> SMS APP</h2>
                <button style={{backgroundColor: 'white'}} type="button" class="btn-close" data-bs-dismiss="modal"></button>
              </div>
            </div>
            <div className='modal-body text-center text-color'>
              <h6 className="text-color mb-4">
                Ingresa tu correo electrónico y recibirás instrucciones para tu registro en <strong>SMS-APP</strong>, obtendrás <strong>GRATIS 2 mensajes</strong> de prueba para que des el paso a una nueva forma de conectar con tus clientes.
              </h6>
              
              <div className="form-group bg-white border rounded px-2 py-2 mb-2">
                 <div className="row">
                     <div className="col">
                                    
                        <input
                          type='email'
                          name="email"
                          autoFocus
                          required
                          className="form-control form-control-email pl-3"
                          placeholder="Enter your email address"
                          value={inputMail}
                          onChange= {(e) => setInputMail(e.target.value)}
                          />
                      </div>
                      <div className="col-auto pt-2">
                          
                          <button type="submit" onClick={handleClick} className="btn btn-email btn-block btn-primary">
                          <i className="fa fa-paper-plane-o mr-2"></i>&nbsp;Enviar
                          </button>
                      </div>
                  </div>
              </div>
                  {
                    notification &&
                      <div className='notification'>
                      <p>{msgNotification}</p>
                    </div>
                  }
            </div>

            <div className='modal-footer text-center'>
              <span className="mb-4 text-color">
                  Si no ves el correo de <strong>smsapp.service@gmail.com</strong> en tu bandeja de entrada , revisa los correos no deseados.</span>
            </div>
          </>


      
  );
})

export default EmailModal
